<template>
    <div>
        Email Confirmation Dummy
         
    </div>
</template>
<script> 

    export default {

        name: 'EmailConfirmation',
        components: { 
        },
        data() {
            return {
            }
        },
        mounted() {
        },
        computed: {
        },
        methods: { 
        }
    }
</script>
<style scoped>
</style>